import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import { queryKeys } from '../query-keys';
import { ApiError } from '../types/errors';

interface KioskConfig {
  kioskId: string;
  code: string;
  name: string;
  locationId: string;
  locationName: string;
}

/**
 * Fetch kiosk configuration by device code (per-device binding).
 * Also serves as the heartbeat — refetches every 60s.
 */
export function useKioskConfigByCode(code: string) {
  return useQuery({
    queryKey: queryKeys.kioskConfig.byCode(code),
    queryFn: () => apiFetch<KioskConfig>(`/api/kiosk/${code}/config`),
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: (count, error) => {
      if (error instanceof ApiError && (error.isForbidden || error.isNotFound)) return false;
      return count < 3;
    },
  });
}
